import React from 'react';
import { Facebook, Instagram } from 'lucide-react';
import { usePublicEvents } from '../hooks/usePublicEvents';
import { LINKS } from '../lib/links';
import { dateMarker, formatLongDate, formatTimes } from '../utils/eventDates';
import { EventCard } from './EventCard';
import { FadeIn } from './FadeIn';
export function UpcomingEvents() {
  const {
    status,
    events
  } = usePublicEvents();

  // Nothing upcoming: remove the section rather than show a stale date.
  if (status === 'ready' && events.length === 0) return null;
  const [featured, ...rest] = events;
  return <section id="events" className="scroll-mt-20 bg-creamDeep px-6 py-20 md:px-12 md:py-28" data-id="element-637" data-mp="2tkicli1jjjft">
      <div className="mx-auto max-w-6xl" data-id="element-638" data-mp="2jsuo9q0a6iik">
        <div className="mb-10 flex flex-col gap-4 md:mb-14 md:flex-row md:items-end md:justify-between" data-id="element-639" data-mp="2jrjo0061nsw7">
          <div data-id="element-640" data-mp="37gvuutdwfovc">
            <FadeIn data-id="element-641" data-mp="37h45eemjui3d">
              <p className="mb-4 text-xs font-medium uppercase tracking-[0.2em] text-clay/70" data-id="element-642" data-mp="3c95g3w42k0ra">
                Upcoming Events
              </p>
            </FadeIn>
            <FadeIn delay={0.1} data-id="element-643" data-mp="3im1f61j5kum8">
              <h2 className="max-w-xl font-serif text-4xl leading-tight text-pine md:text-5xl" data-id="element-644" data-mp="3dmgjbzza52dq">
                What&apos;s coming up on the land.
              </h2>
            </FadeIn>
          </div>
          <FadeIn delay={0.2} className="flex gap-5" data-id="element-645" data-mp="3nkmkugh6c6i2">
            <a href={LINKS.instagram} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm uppercase tracking-widest text-pine transition-colors hover:text-ember" data-id="element-646" data-mp="3nj1oclbaudhk">
              <Instagram className="h-4 w-4" data-id="element-647" data-mp="f5ckbcsxn9ce" />
              Instagram
            </a>
            <span className="text-pine/20" data-id="element-648" data-mp="a5zow3nzwty7">|</span>
            <a href={LINKS.facebook} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm uppercase tracking-widest text-pine transition-colors hover:text-ember" data-id="element-649" data-mp="a69e3p17ux2u">
              <Facebook className="h-4 w-4" data-id="element-650" data-mp="31m0c75p9ruox" />
              Facebook
            </a>
          </FadeIn>
        </div>

        {status === 'loading' && <div className="min-h-[28rem] rounded-sm border border-pine/10 bg-cream/60" aria-busy="true" aria-label="Loading upcoming events" data-id="element-651" data-mp="35owpcgw1iylh" />}

        {featured && <FadeIn data-id="element-652" data-mp="3kkclqsk3f6l1">
            <EventCard event={featured} data-id="element-653" data-mp="3kkw4gbhkhz04" />
          </FadeIn>}

        {rest.length > 0 && <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2" data-id="element-654" data-mp="3okwgjph71y40">
            {rest.map((event, index) => {
          const marker = dateMarker(event.eventDate);
          const times = formatTimes(event.doorsTime, event.showTime);
          return <FadeIn key={event.id} delay={Math.min(index, 4) * 0.06} data-id="element-655" data-mp="756li1u6t45m" data-mpi={index}>
                  <article className="flex h-full items-start gap-5 rounded-sm border border-pine/15 bg-cream p-6" data-id="element-656" data-mp="733jskjo9ml2">
                    {marker && <div className="flex-none border-r border-pine/15 pr-5 text-center" data-id="element-657" data-mp="1wmlkv510xs75">
                        <span className="block text-xs font-medium uppercase tracking-[0.18em] text-clay/70" data-id="element-658" data-mp="1rmpe4y0xzmnw">
                          {marker.weekday}
                        </span>
                        <span className="block font-serif text-3xl leading-none text-ember" data-id="element-659" data-mp="1hpazn3ykx7y8">
                          {marker.day}
                        </span>
                        <span className="block text-xs font-medium uppercase tracking-[0.18em] text-clay/70" data-id="element-660" data-mp="2fc1lrtgmfmo3">
                          {marker.month}
                        </span>
                      </div>}
                    <div className="min-w-0" data-id="element-661" data-mp="20nx5sx8ydp90">
                      <h3 className="mb-2 font-serif text-2xl leading-tight text-pine" data-id="element-662" data-mp="20n5j6bxc31uv">
                        {event.title}
                      </h3>
                      <p className="text-sm font-light leading-relaxed text-clay" data-id="element-663" data-mp="2tcukyrhvb5xj">
                        {[formatLongDate(event.eventDate), times].filter(Boolean).join(' · ')}
                      </p>
                    </div>
                  </article>
                </FadeIn>;
        })}
          </div>}

        <FadeIn delay={0.2} data-id="element-664" data-mp="23xgh5mcfh3hk">
          <p className="mt-8 text-sm font-light leading-relaxed text-clay/70" data-id="element-665" data-mp="23y811zwnxcs0">
            Public sauna nights, workshops and gatherings are posted first on Instagram
            and Facebook. Message Zev to get on the list for the next one.
          </p>
        </FadeIn>
      </div>
    </section>;
}